import apiClient from './apiClient';
import type { CreateLocationRequest, Location, LocationWithDetails } from '../types/location';

export const getAllLocations = async (): Promise<LocationWithDetails[]> => {
  const response = await apiClient.get<LocationWithDetails[]>('/locations');
  return response.data;
};

export const getLocationsByProject = async (
  projectKey: string,
): Promise<Location[]> => {
  const response = await apiClient.get<Location[]>(
    `/locations/project/${projectKey}`,
  );
  return response.data;
};

export const getLocationsBySite = async (
  siteKey: string,
): Promise<Location[]> => {
  const response = await apiClient.get<Location[]>(
    `/locations/site/${siteKey}`,
  );
  return response.data;
};

export const createLocation = async (
  projectKey: string,
  data: CreateLocationRequest,
): Promise<Location> => {
  const response = await apiClient.post<Location>(
    `/locations/project/${projectKey}`,
    data,
  );
  return response.data;
};

export const createLocationForSite = async (
  siteKey: string,
  data: CreateLocationRequest & { ProjectKey: string },
): Promise<Location> => {
  const response = await apiClient.post<Location>(
    `/locations/site/${siteKey}`,
    data,
  );
  return response.data;
};

export interface UpdateLocationData {
  LocationId?: string;
  LocationName?: string;
  LocationType?: string;
  SiteKey?: string;
  ProjectKey?: string | null;
}

export const updateLocation = async (
  locationKey: string,
  data: UpdateLocationData,
): Promise<Location> => {
  const response = await apiClient.put<Location>(`/locations/${locationKey}`, data);
  return response.data;
};

export const deleteLocation = async (locationKey: string): Promise<void> => {
  await apiClient.delete(`/locations/${locationKey}`);
};
